<div class="heka-m3-dialog-container-basic">
  <div class="dialog-header">
    <h4>{{'MULTI_DOMAIN.LEAVE.TITLE'|translate: {companyName: domainToLeave?.companyName} }}</h4>
  </div>
  <mat-dialog-content class="dialog-content">
      {{'MULTI_DOMAIN.LEAVE.DESCRIPTION'|translate}}
      @if(availableDomains.length > 0) {
      <span> {{'MULTI_DOMAIN.LEAVE.SELECT_DOMAIN' | translate}}</span>
      }
      <div class="mt-4 mb-4">
        <mat-radio-group class="d-flex flex-column gap-3" [(ngModel)]="selectedDomainId">
          @for (domain of availableDomains; track domain.domainId) {
          <mat-radio-button color="primary"
            [value]="domain.domainId">{{domain.companyName}}</mat-radio-button>
          }
        </mat-radio-group>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions class="dialog-actions">
    <button mat-button  color="primary" mat-dialog-close>{{'GENERAL.CANCEL'|translate}}</button>
    <button mat-flat-button color="primary" (click)="onLeaveDomain()"
            [disabled]="availableDomains.length > 1 && !selectedDomainId">{{'MULTI_DOMAIN.TABLE.ACTIONS.LEAVE'|translate}}</button>
  </mat-dialog-actions>
</div>
